import { useMemo } from 'react';
import { Modal, Button, Tab } from 'semantic-ui-react';
import Duration from './Duration';
import BasicTable from './table/BasicTable';
import PassFailResult from './PassFailResult'
import Errors from './TestErrors';

function TestsModal({ tests, errors, open, handleClose }) {
	const columns = useMemo(() => [
		{
			Header   : `Title`,
			accessor : `title`,
		},
		{
			Header   : `Duration`,
			accessor : `duration`,
			Cell     : ({ cell }) => <Duration duration={cell.value} />
		},
		{
			Header   : `Retries`,
			accessor : `retries`,
		},
		{
			Header   : `Skipped Hidden`,
			accessor : `skipped`,
		},
		{
			Header   : `Result`,
			accessor : `passed`,
			Cell     : ({ cell }) => <PassFailResult passed={cell.value} skipped={cell.row.values.skipped} />
		},
	], []);

	const panes = [
		{
			menuItem : `Errors`,
			render   : () => <Tab.Pane attached={false}><Errors errors={errors} /></Tab.Pane>
		},
		{
			menuItem : `Tests`,
			render   : () => (
				<Tab.Pane>
					<BasicTable
						columns={columns}
						data={tests}
						hidden_columns={[`skipped`]}
					/>
				</Tab.Pane>
			)
		},
	];

	return (
		<Modal
			size="large"
			closeIcon
			onClose={handleClose}
			open={open}
		>
			<Modal.Header>
				Suite Details
			</Modal.Header>

			<Modal.Content>
				<Tab menu={{ secondary : true, pointing: true }} panes={panes} />
			</Modal.Content>

			<Modal.Actions>
				<Button color="red" onClick={handleClose}>Close</Button>
			</Modal.Actions>
		</Modal>
	)
}

export default TestsModal;
